import { LOCALES } from "../_i18n"

export default function useLocale() {
  return LOCALES.PORTUGUESE_BR
}
